<atx-switch
  inputId="show-wholesale"
  [formControl]="showWholeSalePrices"
  data-e2e="show-wholesale-prices"
>
  <span
    i18n="UserMenu@@userMenuShowWholeSalePricesSwitch"
    class="font-weight-medium"
  >
    Show wholesale prices
  </span>
</atx-switch>

@if (subscribeToAllEmailsAvailable$ | async) {
<atx-switch
  [formControl]="subscribeToAllEmailsControl"
  (change)="subscribeToAllEmailsChange($event)"
  inputId="subscribe-to-emails"
  data-e2e="subscribe-to-emails"
>
  @if (subscribeToAllEmailsControl.value) {
  <span
    i18n="UserMenu@@userMenuDisableSubsribeToEmailsSwitch"
    class="font-weight-medium"
  >
    Unsubscribe to all emails
  </span>
  } @else {
  <span
    i18n="UserMenu@@userMenuEnableSubsribeToEmailsSwitch"
    class="font-weight-medium"
  >
    Subscribe to all emails
  </span>
  }
</atx-switch>
} @if (showAdvancedMDO$ | async) {
<atx-switch
  [formControl]="advancedMDOEnabled"
  (change)="onEnableAdvancedMDOChange($event)"
  inputId="advanced-mdo"
  data-e2e="enable-advanced-mdo"
>
  @if (advancedMDOEnabled.value) {
  <span
    i18n="UserMenu@@userMenuDisableAdvancedMDOSwitch"
    class="font-weight-medium"
  >
    Disable Advanced MDO
  </span>
  } @else {
  <span
    i18n="UserMenu@@userMenuEnableAdvancedMDOSwitch"
    class="font-weight-medium"
  >
    Enable Advanced MDO
  </span>
  }
</atx-switch>
} @if (isDarkModeEnabled$ | async) {
<atx-switch
  class="dark-mode-switch"
  inputId="dark-mode"
  [formControl]="darkMode"
  data-e2e="dark-mode"
>
  @if (darkMode.value) {
  <span
    i18n="UserMenu@@userMenuDarkModeOffSwitch"
    class="font-weight-medium pr-2"
  >
    Dark mode off
  </span>
  } @else {
  <span
    i18n="UserMenu@@userMenuDarkModeOnSwitch"
    class="font-weight-medium pr-2"
  >
    Dark mode on
  </span>
  }
  <div
    i18n="UserMenu@@userMenuDarkModeSwitchBetaLabel"
    class="dark-mode-switch-label d-inline-flex pr-0 p-1"
  >
    beta
  </div>
</atx-switch>
} @if (isPreventZoomRuleEnabled$ | async) {
<atx-switch
  inputId="prevent-zoom"
  [formControl]="preventZoom"
  (change)="onPreventZoomChange($event)"
  data-e2e="dark-mode"
>
  <span i18n="UserMenu@@userMenuPreventZoomSwitch" class="font-weight-medium">
    Prevent zoom
  </span>
</atx-switch>
}
